var _rect, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_busca",
    "data-name": "icon busca",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_542",
    "data-name": "Ret\\xE2ngulo 542",
    width: 35,
    height: 35,
    rx: 5,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(7.891 6.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2255",
    "data-name": "Caminho 2255",
    d: "M15.487,18.741a.585.585,0,0,1-.573.545H3.943a.585.585,0,0,1-.573-.545L2.743,6.651a.858.858,0,0,0-1.714.069l.627,12.089A2.3,2.3,0,0,0,3.943,21H14.914A2.3,2.3,0,0,0,17.2,18.809L17.829,6.72a.856.856,0,1,0-1.711-.072ZM8.743,16.714a.686.686,0,1,0,1.371,0V8.057a.686.686,0,0,0-1.371,0Zm-3.429.021a.686.686,0,1,0,1.371-.041L6.343,8.037a.686.686,0,1,0-1.371.041Zm6.857-.041a.686.686,0,1,0,1.371.041l.343-8.657a.686.686,0,1,0-1.371-.041ZM13.649,2.914l-.326-1.142A2.529,2.529,0,0,0,10.975,0H7.882A2.529,2.529,0,0,0,5.534,1.773L5.208,2.914H.857a.857.857,0,1,0,0,1.714H18a.857.857,0,1,0,0-1.714Zm-2.674-1.2H7.882a.835.835,0,0,0-.7.528l-.189.672H11.87l-.192-.672A.835.835,0,0,0,10.975,1.714Z",
    fill: "#4b4b4b",
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.5d15e227.svg";
export { ForwardRef as ReactComponent };